import { RouteObject } from 'react-router-dom'
import EasyPayLayout from 'layout/easyPay/easyPayLayout'
import PayForOther from './payForOther'
import PayForOtherInLoan from './payForothersInLoan'
import ErrorBug from 'components/errors/bugs'
import EasyGatewayPayPage from './easyPayPage/indexEasyGatewaypage'
import InitGatewayPaymentPage from './init/indexGateway'

/**
 * «پرداخت آسان».
 *
 * The pre-v2 half of this flow — `gateway`, `init`, `money-pool/:id` and
 * `money-pool/init/:id`, each with its own list, receipt and footer — was
 * replaced by `''` + `init-new` on 2025-02-01 and has not been visited by
 * anybody since 2025-02-05 (622 pageviews in its whole life, none in the last
 * eighteen months). It was removed rather than left standing because it still
 * shipped a «استفاده از کیف پول» switch that could not spend the wallet, and a
 * footer that answered a fully-covered wallet payment by navigating to
 * `/group-all-payment`, whose mount re-settles the whole basket.
 */
export const easyPayLayout: RouteObject[] = [
    {
        path: '/easy-pay',
        element: <EasyPayLayout />,
        errorElement: <ErrorBug />,
        children: [
            {
                index: false,
                path: '',
                element: <EasyGatewayPayPage />,
            },
            {
                index: false,
                path: 'init-new',
                element: <InitGatewayPaymentPage />,
            },
            {
                index: false,
                path: 'pay-for-other/:moneyPool',
                element: <PayForOther />,
            },
            {
                index: false,
                path: 'pay-for-other-in-loan/:moneyPool',
                element: <PayForOtherInLoan />,
            },
        ],
    },
]
